export const colors = {
  brand: {
    50: '#ffe5f1',
    100: '#ffcce4',
    200: '#ffb3d7',
    300: '#ff99ca',
    400: '#ff80bd',
    500: '#FF5CAA',
    600: '#ff4da3',
    700: '#ff3396',
    800: '#ff1a88',
    900: '#5d1738',
  },
  primary: '#b34093',
  secondary: '#ffd6f4',
  highlight: '#b9ff5c',
  success: '#82b340',
  default: 'white',
  white: '#ffffff',
  black: '#000000',
}
